import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';

interface Props {
  question: string;
  initialValue?: string;
  onComplete: (answer: string | null) => void;
}

const PromptView: React.FC<Props> = ({
  question,
  initialValue,
  onComplete
}) => {
  const [inputText, setInputText] = React.useState(initialValue ?? '');
  const inputEl = React.useRef<HTMLInputElement>(null);

  const cancel = React.useCallback(() => {
    onComplete(null);
  }, [onComplete]);

  const done = React.useCallback(() => {
    const txt = inputText.trim();
    if (txt.length === 0) {
      onComplete(null);
    } else {
      onComplete(txt);
    }
  }, [inputText, onComplete]);

  React.useEffect(() => {
    if (inputEl.current) {
      inputEl.current.focus();
      if (inputText.length > 0) {
        inputEl.current.select();
      }
    }
  }, []);

  return (
    <div className="alert prompt">
      <div className="content">
        <h1>{question}</h1>
        <p>
          <input
            type="text"
            value={inputText}
            ref={inputEl}
            onChange={e => setInputText(e.target.value)}
          />
        </p>
        <div className="buttons">
          <button className="large secondary" onClick={cancel}>
            Cancel
          </button>
          <button className="large primary" onClick={done}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

const promptAnswer = async (
  question: string,
  initialValue?: string
): Promise<string | null> => {
  return new Promise(resolve => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    window.onpopstate = () => {
      storeDispatch(Actions.closeAllAlerts());
      document.body.removeChild(container);
      resolve(null);
      window.onpopstate = null;
    };
    // at some point this should become: import { createRoot } from 'react-dom/client';
    // @ts-ignore
    const root = ReactDOM.unstable_createRoot(container);
    root.render(
      React.createElement(
        PromptView,
        {
          question,
          initialValue,
          onComplete: value => {
            document.body.removeChild(container);
            resolve(value);
            window.onpopstate = null;
          }
        },
        null
      )
    );
  });
};

export { PromptView, promptAnswer };



// WEBPACK FOOTER //
// ./src/components/PromptView.tsx